import api from './authService';

/**
 * Get all incoming emails
 * @param {Object} filters - Optional filters (status, startDate, endDate, limit)
 * @returns {Promise} Response with incoming emails
 */
export const getIncomingEmails = (filters = {}) => {
  const params = new URLSearchParams();

  if (filters.status) params.append('status', filters.status);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.limit) params.append('limit', filters.limit);

  return api.get(`/email/incoming?${params.toString()}`);
};

/**
 * Get a specific incoming email
 * @param {string} id - Email ID
 * @returns {Promise} Response with email details
 */
export const getIncomingEmail = (id) => {
  return api.get(`/email/incoming/${id}`);
};

/**
 * Delete an incoming email
 * @param {string} id - Email ID
 * @returns {Promise} Response
 */
export const deleteIncomingEmail = (id) => {
  return api.delete(`/email/incoming/${id}`);
};

/**
 * Get email service info
 * @returns {Promise} Response with service info
 */
export const getEmailInfo = () => {
  return api.get('/email/info');
};

/**
 * Submit a raw email for processing
 * @param {string} rawEmail - Raw email content
 * @returns {Promise} Response with processing result
 */
export const submitEmail = (rawEmail) => {
  return api.post('/email/submit', { rawEmail });
};

/**
 * Sync emails from IMAP/POP3 mailbox
 * @param {Object} config - Optional mailbox configuration
 * @returns {Promise} Response with sync results
 */
export const syncMailbox = (config = null) => {
  return api.post('/email/mailbox/sync', config || {});
};

/**
 * Test mailbox connection
 * @param {Object} config - Mailbox configuration
 * @returns {Promise} Response with test results
 */
export const testMailboxConnection = (config) => {
  return api.post('/email/mailbox/test', config);
};

/**
 * Get mailbox configuration status
 * @returns {Promise} Response with config status
 */
export const getMailboxConfig = () => {
  return api.get('/email/mailbox/config');
};
